module.exports = __webpack_public_path__ + "static/media/portAntonio_jamaika.76ee9ba2.jpg";